module.exports = __webpack_public_path__ + "img/interior_6.1.7e74529f.jpg";